/* istanbul ignore file */

import styled from 'styled-components';
import type theme from '@shared/theme';

const AlignMap = {
    left: 'flex-start',
    right: 'flex-end',
    center: 'center',
    top: 'flex-start',
    bottom: 'flex-end',
    'space-between': 'space-between',
    stretch: 'stretch',
    baseline: 'baseline',
};

export type Props = {
    spacing?: keyof typeof theme.spacing | 'none';
    $align?: keyof typeof AlignMap;
    $verticalAlign?: keyof typeof AlignMap;
    $stack?: 'vertical' | 'horizontal';
    $gap?: number;
    $disabled?: boolean;
};

const Block = styled.div<Props>`
    margin-bottom: ${({ theme, spacing }) =>
        spacing && spacing !== 'none' ? theme.spacing[spacing] : 0};

    ${({ $align, $stack }) =>
        $align !== undefined &&
        ($stack === undefined || $stack === 'horizontal') &&
        `
        display: flex; 
        justify-content: ${AlignMap[$align] || 'center'};
    `};

    ${({ $align, $stack }) =>
        $align !== undefined &&
        $stack === 'vertical' &&
        `
        display: flex; 
        align-items: ${AlignMap[$align] || 'center'};
    `};

    ${({ $stack }) =>
        $stack !== undefined &&
        `
        display: flex; 
        flex-direction: ${$stack === 'vertical' ? 'column' : 'row'};
    `};

    ${({ $gap }) =>
        $gap !== undefined &&
        `
        gap: ${$gap}px; 
    `};

    ${({ $verticalAlign }) =>
        $verticalAlign !== undefined &&
        `
        display: flex;
        align-items: ${AlignMap[$verticalAlign] || 'flex-start'};
    `};

    ${({ $disabled }) =>
        $disabled &&
        `
        pointer-events: none;
        opacity: 0.5;
    `};
`;

export default Block;
